// src/auth/routing/RequireAuth.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";

export default function RequireAuth({ children }) {
  const { user, isInitialising } = useAuth(); //
  const location = useLocation(); //

  if (isInitialising) {
    return <div>Checking your session...</div>; //
  }

  if (!user) {
    // Redirect to login and save the attempted URL for post-login return
    return <Navigate to="/auth/sign-in" state={{ from: location }} replace />;
  }

  return children;
}